module.exports = __webpack_public_path__ + "img/tvj_logo.6d11c372.png";